import containerFuild from '../html-snippets/container-fuild';
import css from '../css-snippets/section-card-compare-sowhatbuy';
const html = `
<div data-attribute="wrap-card" class="container wrap-card">
  <div data-attribute="card-title" class="card-title" data-show="true">
    <h2 style="text-align:center;">See More, <span style="color:#c74f23;">Clear &amp; Eye-Friendly</span>
    </h2>
    <p style="text-align:center;">Goodbye to adjustments, long-lasting comfort, and regained independence.</p>
  </div>
  <div data-attribute="wrap-content" data-bg-content="#1c150c" data-color-text="#ffffff" class="wrap-sidebyside"
    style="--bg-content: #1c150c; --color-text: #ffffff">
    <div data-use-vide="true" data-attribute="left-card" data-order="1" class="left-card" style="--order-media: 1">
      <div class="wrap-media">
        <div class="wrap-video">
          <video muted="" loop="" autoplay="" playsinline=""
            src="https://cdn.shopify.com/videos/c/o/v/df1b306feb354bf0b01c66c06781837d.mp4"></video>
        </div>
        <div class="wrap-img" style="display: none;">
          <img src="" alt="">
        </div>
      </div>
      <div data-attribute="list-benefits" class="list-benefits">
        <div data-attribute="item-benefit" class="item-benefit">
          <p><span style="color:hsl( 16, 70%, 46% );"><strong>108x63 mm</strong></span></p>
          <p>Large Lens</p>
        </div>


        <div data-attribute="item-benefit" class="item-benefit">
          <p><span style="color:hsl( 16, 70%, 46% );"><strong>4x</strong></span></p>
          <p>Magnification</p>
        </div>


        <div data-attribute="item-benefit" class="item-benefit">
          <p><span style="color:hsl(16,70%,46%);"><strong>+30%</strong></span></p>
          <p>Wider View</p>
        </div>
      </div>
    </div>
    <div data-attribute="right-card" data-order="2" class="right-card" style="--order-content: 2">
      <div class="compare-by-image">
        <div data-attribute="left-compare" class="left-compare">
          <div class="wrap-imge">
            <img data-attribute="img-left"
              src="https://cdn.skyfastimg.com/images/2026/07/02/image-6a45ea07303ac9d66196f849.jpg" alt="">
          </div>
          <div data-attribute="title-compare-left" data-color-title-compare-left="#ffffff"
            data-bg-title-compare-left="#535353" class="wrap-title"
            style=" --color-title-compare-left: #ffffff; --bg-title-compare-left: #535353;">Standard:</div>
        </div>
        <div data-attribute="right-compare" class="right-compare">
          <div class="wrap-imge">
            <img data-attribute="img-right"
              src="https://cdn.skyfastimg.com/images/2026/07/02/image-6a45ea07303ac9d66196f849.jpg" alt="">
          </div>
          <div data-attribute="title-compare-right" data-color-title-compare-right="#ffffff"
            data-bg-title-compare-right="#c75023" class="wrap-title"
            style=" --color-title-compare-right: #ffffff; --bg-title-compare-right: #c75023;">Our Magnifier:</div>
        </div>
      </div>
      <div class="compare-by-text">
        <div data-attribute="item-compare-by-text" class="item-compare-by-text">
          <div class="icon-prefix">
            <img data-attribute="icon-prefix"
              src="https://cdn.skyfastimg.com/images/2026/07/02/image-6a461a68821a28fb87502ee2.png" alt="">
          </div>
          <div data-attribute="text-compare" class="text-compare">Zero Distortion, Clear View</div>
          <div class="icon-suffix">
            <img data-attribute="icon-suffix"
              src="https://cdn.skyfastimg.com/images/2026/07/02/image-6a461a801aef25173d1a999f.png" alt="">
          </div>
        </div>


        <div data-attribute="item-compare-by-text" class="item-compare-by-text">
          <div class="icon-prefix">
            <img data-attribute="icon-prefix"
              src="https://cdn.skyfastimg.com/images/2026/07/02/image-6a461a68821a28fb87502ee2.png" alt="">
          </div>
          <div data-attribute="text-compare" class="text-compare">Zero Distortion, Clear View</div>
          <div class="icon-suffix">
            <img data-attribute="icon-suffix"
              src="https://cdn.skyfastimg.com/images/2026/07/02/image-6a461a801aef25173d1a999f.png" alt="">
          </div>
        </div>


        <div data-attribute="item-compare-by-text" class="item-compare-by-text">
          <div class="icon-prefix">
            <img data-attribute="icon-prefix"
              src="https://cdn.skyfastimg.com/images/2026/07/02/image-6a461a68821a28fb87502ee2.png" alt="">
          </div>
          <div data-attribute="text-compare" class="text-compare">Zero Distortion, Clear View</div>
          <div class="icon-suffix">
            <img data-attribute="icon-suffix"
              src="https://cdn.skyfastimg.com/images/2026/07/02/image-6a461a801aef25173d1a999f.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
  <a class="btn-banner" data-bg-button="#c75023" data-color-button="#ffffff" data-show-discount="false" data-show="true"
    data-attribute="btn-cta-banner" href="#" style="--bg-button:#c75023; --color-button:#ffffff;">
    <div class="group-discount" style="display: none;">
      <div class="wrap-discount">
        <img src="https://cdn.skyfastimg.com/images/2026/07/01/image-6a44e00b33a0a534b9e66352.png" alt="">
        <div class="wra-value-discount">
          <span data-attribute="value-discount" class="value-discount">50</span>
          <span>%</span>
          <span>OFF</span>
        </div>
      </div>
    </div>
    <div data-attribute="text-button" class="text-btn">BUY NOW &amp; GET 50% OFF</div>
    <div data-show="true" data-attribute="icon-btn" class="icon-btn" style="">
      <img src="https://cdn.skyfastimg.com/images/2026/07/01/image-6a44e08a0c7782f8d8631e33.png" alt="">
    </div>
  </a>
</div>
`;
export default containerFuild(html, css);
